import { CONFIG } from './wiki';

export const getters = {
  currentConfig: ({ mode, currentStatus }) =>
    CONFIG.STATUS[currentStatus?.id || 'NONE']?.[mode] || null,

  currentTabState: ({ currentTab, tabsState }) =>
    tabsState?.tabs?.[currentTab] || null,

  tabsSectionsState: ({ tabsState }) => {
    if (!tabsState?.tabs) return null;
    const tabs = Object.entries(tabsState.tabs);
    return (
      tabs?.reduce(
        (s, [tab, { sections }]) => ({ ...s, [tab]: sections }),
        {}
      ) || null
    );
  },

  currentTabSectionsState: (_, { currentTabState }) =>
    currentTabState?.sections || null,
};
